import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import config from '../../admin/config';

@Component({
  host: { class: 'py-large' },
  selector: 'login-parent',
  styleUrls: ['./login-parent.component.scss'],
  templateUrl: './login-parent.component.html',
})
export class LoginParentComponent implements OnInit {
  constructor(private metaService: Meta) {}

  readonly envIsZelis = config.envIsZelis;

  ngOnInit() {
    if (this.envIsZelis) {
      this.metaService.addTag({ name: 'robots', content: 'noindex' });
    }
  }
}
